import * as React from "react";
const SvgFiRrStoreAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-store-alt_svg__a)">
      <path
        fill="#062147"
        d="M24 8a1 1 0 0 0-.038-.275L22.79 3.626A5.02 5.02 0 0 0 17.982 0H6.017a5.02 5.02 0 0 0-4.808 3.626L.039 7.725A1 1 0 0 0 0 8c0 1.012.378 1.937 1 2.643V20c0 2.206 1.794 4 4 4h6c2.206 0 4-1.794 4-4v-8.537a4 4 0 0 0 1-.82A3.99 3.99 0 0 0 19 12h1q.519-.001 1-.127V23a1 1 0 1 0 2 0V10.643c.622-.705 1-1.631 1-2.643M11 22H5c-1.103 0-2-.897-2-2v-2h10v2c0 1.103-.897 2-2 2m2-6H3v-4.127q.481.126 1 .127h1a4 4 0 0 0 3-1.357A4 4 0 0 0 11 12h2zm6-6c-1.103 0-2-.897-2-2a1 1 0 1 0-2 0c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2a1 1 0 0 0-2 0c0 1.103-.897 2-2 2H4c-.49 0-.94-.178-1.288-.471a1.99 1.99 0 0 1-.708-1.402l1.128-3.951A3.01 3.01 0 0 1 6.017 2H7v2a1 1 0 0 0 2 0V2h6v2a1 1 0 1 0 2 0V2h.982c1.332 0 2.519.895 2.885 2.176l1.129 3.951A2.003 2.003 0 0 1 20 10.001z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-store-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStoreAlt;
